import { ArrowCounterClockwise, Calendar, CaretLeft, Check, CircleNotch, Clock, DownloadSimple, Envelope, MapPin, VideoCamera } from '@phosphor-icons/react'
import React, { useEffect, useMemo, useState } from 'react'
import { Button, notify } from 'app/components'
import Accordions from './accordians';
import { getBase64 } from '../../../utils/commonUtils';
import { useSelector } from 'react-redux';
import { addMilliseconds, format, formatDistanceToNowStrict, isFuture, isPast, isSameDay, isWithinInterval, subMilliseconds } from 'date-fns';
import { resendTickets } from '../api';
import { getBookingRefundInfo } from '../api';
import { TIME_INTERVAL_CONFIG } from '../../../constants/timeIntervalConfig';

const getDateRange = (start, end) => {
  if (!start || !end) return '';

  if (isSameDay(start, end)) return format(start, 'dd MMM yyyy');
  
  return `${format(start, 'dd MMM yy')} - ${format(end, 'dd MMM yy')}`;
};

const getTimeRange = (start, end) => {
  if (!start || !end) return '';

  return `${format(start, 'hh:mm aa')} - ${format(end, 'hh:mm aa')}`;
};

const BookingDetail = (props) => {
  const {
    id,
    bookingId,
    booking_date: bookingDate,
    onAllTicketsClick,
    refundStatus,
    statusTags,
    onRefundClick,
    blobUrl,
    event_details: eventDetails,
    ticket_details: ticket,
    tickets_booked: totalTickets,
    get_to_know_details: attendeeBookingDetails,
  } = props;

  const { userData, activeRequests } = useSelector((state) => state.app);
  const { details: attendeeList = [] } = attendeeBookingDetails || {};
  const [refundInfo, setRefundInfo] = useState(null);
  const isResending = useMemo(() => activeRequests?.includes('resend-tickets'), [activeRequests]);

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])

  const isCancelled = eventDetails.status === "CANCELLED";
  const isRescheduled = eventDetails.is_reschedule === true;

  const ticketsDetails = useMemo(() => {
    if (eventDetails?.smp_detail_entity_set?.length) {
      const config = {};
      eventDetails?.smp_detail_entity_set?.forEach((ticket) => {
        config[ticket?.id] = ticket;
      });

      return config;
    }

    return {};
  }, [eventDetails?.smp_detail_entity_set]);

  const parseMaybeArrayOrEpoch = (value) => {
    if (!value) return null;

    if (Array.isArray(value)) {
      const [y, m, d, h = 0, min = 0, s = 0] = value;
      // assume backend gave UTC array → convert to local
      return new Date(Date.UTC(y, m - 1, d, h, min, s));
    }

    if (typeof value === 'number') {
      // if epoch timestamp
      return new Date(value);
    }

    if (typeof value === 'string') {
      // handle ISO string or DB timestamp
      return new Date(value);
    }

    return null;
  };


  function isPastDate(dateArray) {
    if (!Array.isArray(dateArray)) {
      return false;
    }

    const rescheduleTime = parseMaybeArrayOrEpoch(dateArray);

    const bookingDateObj = new Date(bookingDate);

    const checking = rescheduleTime > bookingDateObj;

    return checking;
  }
  
  useEffect(() => {
    const fetchRefundInfo = async () => {
      if (props?.ticket_status === 'REFUNDED') {
        try {
          getBookingRefundInfo(props?.ticket_details[0]?.smp_id, (response) => {
            if (response) {
              const matchingRefund = response.find(
                refund => refund?.ref_payment_id === props?.pg_payment_id
              );
              if (matchingRefund) {
                setRefundInfo({ data: matchingRefund });
                console.log('refund info', refundInfo);
              }
            }
          })} 
          catch (error) {
          console.error('Error fetching refund info:', error);
        }
      }
    };
    fetchRefundInfo();
  }, [props?.ticket_status, props?.ticket_details, props?.payments]);

  const isMeetLinkEnabled = isWithinInterval(new Date(), { start: subMilliseconds(new Date(eventDetails?.start_date), TIME_INTERVAL_CONFIG.MEET_JOIN_START), end: addMilliseconds(new Date(eventDetails?.end_date), TIME_INTERVAL_CONFIG.MEET_JOIN_END) });

  const questionsMap = useMemo(() => {
    const questions = {};
    eventDetails?.get_to_know_details?.forEach((item) => {
      questions[item.id] = item;

      if (item?.conditions?.length) {
        item?.conditions?.forEach((choice) => {
          questions[choice?.config?.id] = choice?.config;
        });
      }
    });

    return questions;

  }, [eventDetails?.get_to_know_details]);

  const onClickResend = () => {
    resendTickets(id, () => {
      notify('success', 'Reset tickets to your email successfully!');
    }, () => {
      notify('error', 'Failed to resend tickets.');
    });
  };

  return (
    <div className={`${window.innerWidth < 650 ? 'w-full': 'w-[640px] mx-auto'} flex flex-col md:py-2 gap-6 md:gap-1 p-6`}>
      <div onClick={onAllTicketsClick}><div className='gap-1 text-14 flex items-center pb-4 md:pb-12 cursor-pointer'><CaretLeft size='20'
        color='#101010'/>All tickets</div></div>
    <div className='p-6 rounded-xl shadow-xl bg-white'>
      <div className='flex flex-col gap-4'>
        {/* <div className='flex justify-between'>
          <div className='label-14 border border-dashed border-grey-10 px-3 py-2 rounded-md'>{bookingId}</div>
        {(!isCancelled) && isFuture(eventDetails?.start_date) && (<div className='!leading-[unset] text-primary-green bg-light-green px-3 py-2 rounded-2xl label-12 uppercase'>{`Coming up in ${formatDistanceToNowStrict(eventDetails?.start_date)}`}</div>)}
        {isCancelled && (<div className='text-error bg-light px-3 py-2 rounded-2xl text-xs font-medium'>CANCELLED</div>)}
    
        </div> */}
        <div className='flex justify-between gap-2 items-center'>
  {/* Booking ID */}
  <div className='label-14 border border-dashed border-grey-10 px-3 py-2 rounded-md'>
    {bookingId}
  </div>

  {/* Event Tags */}
  <div className='flex gap-2 items-center'>
    {/* Rescheduled Tag */}
    {isRescheduled && !isCancelled && isPastDate(eventDetails?.reschedule_time) && (
      <div className='text-[#23AB37] bg-[#E5FFF6] px-3 py-2 rounded-2xl text-xs font-medium'>
        EVENT RESCHEDULED
      </div>
    )}

    {/* Coming up */}
    {!isCancelled && isFuture(eventDetails?.start_date) && (
      <div className='!leading-[unset] text-primary-green bg-light-green px-3 py-2 rounded-2xl label-12 uppercase'>
        {`Coming up in ${formatDistanceToNowStrict(eventDetails?.start_date)}`}
      </div>
    )}

    {/* Cancelled Tag */}
    {isCancelled && (
      <div className='text-error bg-light px-3 py-2 rounded-2xl text-xs font-medium'>
        CANCELLED
      </div>
    )}
  </div>
</div>

     
        <div className='heading-16'>{eventDetails?.name}</div>
        <div className='flex items-start gap-2'>
          <Calendar size={20}/>
          <div className='flex flex-col gap-1'>
            <div className='text-12 text-grey-70'>Date</div>  
            <div className='label-16'>{getDateRange(eventDetails?.start_date, eventDetails?.end_date)}</div>
          </div> 
        </div>  
        <div className='flex items-start gap-2 pb-8 '>
          <Clock size={20}/>
          <div className='flex flex-col gap-1'>
            <div className='text-12 text-grey-70'>Time</div>  
            <div className='label-16'>{getTimeRange(eventDetails?.start_date, eventDetails?.end_date)}</div>
          </div> 
        </div> 
        <div className='flex text-center items-center justify-center text-primary text-12 relative border-b border-dashed border-b-primary'>
          <div className='bg-light px-3 py-1 rounded-xl absolute'>
            {`${totalTickets} x ${ticketsDetails?.[ticket?.[0]?.ticket_tier_id]?.option_value_1}`}
          </div>
        </div>      
        {!isCancelled && ( 
                  eventDetails?.type !== 'online' ? (
                    <div className='flex items-center justify-center flex-col p-9 pt-6 qr m-0 border-b border-grey-50'>
                      <img src={blobUrl} width={200} height={200} />
                    </div>)
                  :
                  (<div className='flex items-start gap-2 w-full'>
                    <VideoCamera size={20}/>
                    <div className='flex flex-col w-full'>
                      <div className='flex justify-between w-full'>
                        <div className='flex flex-col gap-1'>
                          <div className='text-12 text-grey-70 mb-1'>Where?</div>   
                          <div className='label-16'>Online</div>
                          {(!isMeetLinkEnabled && !isPast(eventDetails?.start_date))&& <div className='text-12 text-grey-70'>Event link will be active 30mins before start time.</div>}
                        </div>
                        <Button
                          type='primary-black'
                          size='small'
                          disabled={!isMeetLinkEnabled}
                          onClick={() => window.open(eventDetails?.meeting_link, '_blank')}
                        >
                          Join
                        </Button>
                      </div>           
                    </div> 
                  </div>) 
         )}
         {(!isCancelled && eventDetails?.type === 'online' && isMeetLinkEnabled) && (
          <>
          <div className='flex flex-col w-full ml-7'>
            <div className='text-12 text-grey-70 mb-1'>Meeting Link</div>  
            <div className='flex justify-between w-full'>
              <div className='label-16'>{eventDetails?.meeting_link}</div>
            </div>           
          </div>
          {eventDetails?.meeting_password && (<div className='flex flex-col w-full ml-7'>
            <div className='text-12 text-grey-70 mb-1'>Password</div>  
            <div className='flex justify-between w-full'>
              <div className='label-16'>{eventDetails?.meeting_password}</div>
            </div>           
          </div>)}
          </>
         )}
          {(!isCancelled && eventDetails?.type === 'offline') && ( 
        <div className='flex items-start gap-2 pt-4 w-full'>
          <MapPin size={20}/>
          <div className='flex flex-col w-full'>
            <div className='text-12 text-grey-70 mb-1'>Venue</div>  
            <div className='flex justify-between w-full'>
              <div className='label-16'>{eventDetails?.event_address?.name}</div>
              <a className='text-primary label-12 no-underline' target='_blank' href={`https://www.google.com/maps/place/${eventDetails?.event_address?.location?.lat},${eventDetails?.event_address?.location?.lng}`}>Directions</a>
            </div>           
          </div> 
        </div> 
          )}
       {!isCancelled && ( 
        <div className='flex items-start gap-2 pt-4'>
          <Envelope size={20}/>
          <div className='flex flex-col'>
            <div className='text-12 text-grey-70 mb-1'>Delivered to</div>  
            <div className='flex flex-col'> 
              <div className='label-16'>{userData?.email}</div>
              <div className='label-16'>{userData?.mobile}</div>
            </div>
          </div> 
        </div>
       )}
        <div className='flex items-start gap-2 pt-4'>
          <Check size={20}/>
          <div className='flex flex-col'>
            <div className='text-12 text-grey-70 mb-1'>Purchased on</div>  
            <div className='label-16'>{format(new Date(bookingDate), 'dd MMM yyyy, hh:mm a')}</div>
          </div> 
        </div> 
       
        {!isCancelled && !isPast(eventDetails?.end_date) && ( 
        <div className='flex justify-around'>
          <div
            className={`py-3 px-6 ${isResending ? 'text-grey-50 cursor-not-allowed' : 'text-primary'} label-14 flex items-center gap-2 justify-center  cursor-pointer`}
            onClick={isResending ? null : onClickResend}
          >
            {isResending ? (
              <CircleNotch
                className="loader-icon"
                size={20}
                color="#B7B7B7"
              />
            ) : (<ArrowCounterClockwise 
              size={20}
              color='#FF2459'/>)}
            {isResending ? 'Resending tickets' : 'Resend tickets'}
          </div>
          {/* <div className='py-3 px-6 text-primary label-14 flex items-center gap-2 justify-center  cursor-pointer '>
            <DownloadSimple 
              size={20}
              color='#FF2459'/>
            Download</div> */}
        </div>
        )}

      </div> 
    </div>
    <Accordions
      isCancelled={isCancelled}
      refundInfo={refundInfo} 
      bookingDetails={attendeeList}
      ticketsDetails={ticketsDetails}
      ticketStatus = {props?.ticket_status}
      ticketCategory={`${totalTickets} x ${ticketsDetails?.[ticket?.[0]?.ticket_tier_id]?.option_value_1}`}
      ticketDescription={ticketsDetails?.[ticket?.[0]?.ticket_tier_id]?.description}
      questionsMap={questionsMap}
    />
    </div>
  )
}

export default BookingDetail
